import { Box } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { browseRootPath } from "@outschool/routes";
import { useSession } from "@outschool/ui-auth";
import { useTopNoticeContext } from "@outschool/ui-components-website";
import {
  Banner,
  ConditionalTrackingPageSection
} from "@outschool/ui-legacy-component-library";
import { Screen, useDimensions, useOnScreen } from "@outschool/ui-utils";
import React from "react";
import ReactDOM from "react-dom";

import ErrorMessage from "../ErrorMessage";
import JoinAndWelcomeButton from "../JoinAndWelcomeButton";
import Link from "../Link";
import { StandardHeader } from "./Header";
import HeaderLogo from "./HeaderLogo";

function StickyMobileHeaderLeft() {
  const { t } = useTranslation("client\\components\\nav\\StickyMobileHeader");
  const { isLoggedIn } = useSession();
  return isLoggedIn ? (
    <Link to={browseRootPath()} trackingName="nav_logo">
      <HeaderLogo isWhiteText={false} />
    </Link>
  ) : (
    <JoinAndWelcomeButton>{t`Join for Free`}</JoinAndWelcomeButton>
  );
}

export default function StickyMobileHeader({
  hideFindClasses = false,
  leftChildren = <StickyMobileHeaderLeft />,
  watchNode = null,
  error = null
}): React.ReactPortal {
  const [bottomNode, setBottomNode] = React.useState();
  const [containerNode, setContainerNode] = React.useState();
  const isWatchNodeOnScreen = useOnScreen(watchNode || bottomNode, true);
  const containerDimensions = useDimensions(containerNode);
  const topOffset = containerDimensions.height
    ? -containerDimensions.height
    : "-100vh";
  const isMobile = Screen.useIsMobile();
  const { topNotice, timedTopNotice } = useTopNoticeContext();
  const displayedError = error || topNotice || timedTopNotice;
  // @ts-ignore TS(2322): Type 'ReactPortal | null' is not assignable to typ... Remove this comment to see the full error message
  return !isMobile
    ? null
    : ReactDOM.createPortal(
        <ConditionalTrackingPageSection
          name="sticky_mobile_header"
          uniqueId={"sticky_mobile_header"}
        >
          {setImpressionNode => (
            <Box ref={setImpressionNode}>
              <Box
                ref={setBottomNode}
                sx={{
                  position: "relative",
                  bottom: 0
                }}
              />
              <Box
                ref={setContainerNode}
                sx={{
                  position: "fixed",
                  top: isWatchNodeOnScreen ? topOffset : 0,
                  left: 0,
                  right: 0,
                  zIndex: 1000,
                  transition: "top 0.3s ease"
                }}
              >
                <StandardHeader
                  hideFindClasses={hideFindClasses}
                  leftChildren={leftChildren}
                />
                {displayedError && (
                  <Banner>
                    <ErrorMessage value={displayedError} />
                  </Banner>
                )}
              </Box>
            </Box>
          )}
        </ConditionalTrackingPageSection>,
        document.body
      );
}
